import PropTypes from "prop-types";
import React, { useState } from "react";
import Button from "../../../Button/Button";
import UpdateIpForm from "./UpdateIpForm";

const Rejected = (props) => {
  const {
    showAlert,
    setShowAlert,
    application,
    goToNext,
    isSubmitting,
    submitApplication,
    userType
  } = props;

  const [state, setState] = useState({
    showUpdate: false,
  });

  const goToUpdate = () => {
    setState({
      ...state,
      showUpdate: true,
    });
  };

  return !state.showUpdate ? (
    <div>
      <div className="nip-integration-header">Share Public Keys</div>
      <br />
      {showAlert && (
        <div className="nip-public-keys-alert2">
          <div className="text2">
            Your application was rejected, please provide the IP information and share
            your public keys to continue. Thank you.
          </div>
          <div className="close2" data-testid="closeAlert" onClick={() => setShowAlert(false)}>
            X
          </div>
        </div>
      )}

      <div className="update-app">
        <div className="text">
          Your application was rejected and access to run integration test has been
          declined
        </div>
        <Button
          className="button"
          type="submit"
          width="50%"
          height="50px"
          text="UPDATE"
          testId="goToUpdate"
          disabled={userType !== "company_network_manager"}
          onClick={() => goToUpdate()}
        />
      </div>
    </div>
  ) : (
    <UpdateIpForm
      application={application}
      goToNext={goToNext}
      isSubmitting={isSubmitting}
      submitApplication={submitApplication}
    />
  );
};

Rejected.propTypes = {
  application: PropTypes.any,
  goToNext: PropTypes.any,
  isSubmitting: PropTypes.any,
  setShowAlert: PropTypes.func,
  showAlert: PropTypes.any,
  submitApplication: PropTypes.any,
  userType: PropTypes.string
}

export default Rejected;
